<template>
	<div>
		<div>{{ label }} </div>
		<div v-if="mode">
			<b-form-radio-group
				v-model="selectedValue"
				:options="options"
			/>
		</div>
		<div v-if="!mode">
			<span v-if="selectedValue">Certified</span>
			<span v-if="!selectedValue">Not Certified</span>
		</div>
	</div>
</template>

<script>
export default {
    name: 'RadioInput',
    props: {
        mode: {
            type: Boolean,
            required: true
        },
        value: {
            type: Boolean,
            required: true
        },
        variable: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: false,
            default: ''
        },
    },
    data() {
        return {
            selectedValue: this.value,
            options: [
                { text: 'Yes', value: true },
				{ text: 'No', value: false }
			]
        }
    },
    computed: {

    },
    watch: {
        value: {
			value: true,
			handler(newVal) {
				this.selectedValue = newVal;
			},
		},
        selectedValue: {
			immediate: true,
			handler(newVal) {
				this.$emit('update', this.variable, newVal);
			},
		}
    },
    methods: {
    },
}
</script>